import React, { createContext, useContext } from 'react'
import { priceValues } from '../utils/helpers'

const PricesContext = createContext()

const PricesProvider = ({ prices, children }) => (
  <PricesContext.Provider value={{ prices: priceValues(prices) }}>
    {children}
  </PricesContext.Provider>
)

const usePricesData = () => {
  return useContext(PricesContext)
}

export { PricesProvider, usePricesData }